import { Box, Grid, TextField, Typography, FormControl, InputLabel, Select, MenuItem, SelectChangeEvent } from '@mui/material';
import { AccountTypes, InitialStateErrorType, InitialStateType } from '../constants/StaticData';
import React from 'react';
type BankDetailsFormProps = {
  data: InitialStateType;
  errors: InitialStateErrorType;
  handleChange?: (
    event: React.ChangeEvent<HTMLInputElement | HTMLTextAreaElement> | SelectChangeEvent
  ) => void;
  maybeForceAutofill?: () => void;
};
const BankDetailsForm: React.FC<BankDetailsFormProps> = ({ data, handleChange = () => {}, errors ,maybeForceAutofill}) => {
  return (
    <Box
      sx={{
        border: 1,
        borderColor: 'divider',
        borderRadius: 1,
        p: 2,
        mb: 2,
      }}
    >
      <Typography variant="subtitle1" color="primary" gutterBottom>
        Bank Details
      </Typography>

      <Grid container spacing={2}>
        <Grid item xs={12} sm={6}>
          <TextField
            label="IFSC Code"
            fullWidth
            size="small"
            margin="dense"
            value={data?.ifscCode}
            name="ifscCode"
            onChange={handleChange}
            error={Boolean(errors?.ifscCode)}
            helperText={errors?.ifscCode}
          />
        </Grid>

        <Grid item xs={12} sm={6}>
          <TextField
            label="Bank Name"
            fullWidth
            size="small"
            margin="dense"
            value={data?.bankName}
            name="bankName"
            onChange={handleChange}
            onBlur={maybeForceAutofill} 
            error={Boolean(errors?.bankName)}
            helperText={errors?.bankName}
          />
        </Grid>

        <Grid item xs={12} sm={6}>
          <TextField
            label="Branch"
            fullWidth
            size="small"
            margin="dense"
            value={data?.branch}
            name="branch"
            onChange={handleChange}
            onBlur={maybeForceAutofill} 
            error={Boolean(errors?.branch)}
            helperText={errors?.branch}
          />
        </Grid>

        <Grid item xs={12} sm={6}>
          <TextField
            label="Account Number"
            type="number"
            fullWidth
            size="small"
            margin="dense"
            value={data?.accountNumber}
            name="accountNumber"
            onChange={handleChange}
            onBlur={maybeForceAutofill} 
            error={Boolean(errors?.accountNumber)}
            helperText={errors?.accountNumber}
            inputProps={{
              maxLength: 16,
              inputMode: 'numeric',
              pattern: '[0-9]*',
              style: { MozAppearance: 'textfield' },
            }}
            sx={{
              '& input::-webkit-outer-spin-button, & input::-webkit-inner-spin-button': {
                WebkitAppearance: 'none',
                margin: 0,
              },
              '& input': {
                MozAppearance: 'textfield',
              },
            }}
          />
        </Grid>

        <Grid item xs={12} sm={6}>
          <TextField
            label="SWIFT Code"
            fullWidth
            size="small"
            margin="dense"
            value={data?.swiftCode}
            name="swiftCode"
            onChange={handleChange}
            error={Boolean(errors?.swiftCode)}
            helperText={errors?.swiftCode}
          />
        </Grid>

        <Grid item xs={12} sm={6}>
          <FormControl fullWidth size="small" margin="dense" error={Boolean(errors?.accountType)}>
            <InputLabel>Account Type</InputLabel>
            <Select value={data?.accountType} label="Account Type" name="accountType" onChange={handleChange} size="small">
              {AccountTypes?.map((option) => (
                <MenuItem key={option.value} value={option.value}>
                  {option.value === '' ? <em>{option.label}</em> : option.label}
                </MenuItem>
              ))}{' '}
            </Select>
            {errors?.accountType && (
              <Typography variant="caption" color="error" sx={{ mt: 1 }}>
                {errors.accountType}
              </Typography>
            )}
          </FormControl>
        </Grid>
      </Grid>
    </Box>
  );
};

export default BankDetailsForm;
